import { IconSizeEnum, InformationIcon, Tooltip } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

type THelpTourProps = {
  tour: () => void;
};
export function HelpTour({ tour }: THelpTourProps) {
  const { t } = useTranslation();

  const handleStartTour = () => {
    tour();
  };

  return (
    <div onClick={handleStartTour} className="cursor-pointer" id="help">
      <Tooltip help={t('Ayuda')} grow>
        <InformationIcon size={IconSizeEnum.SM} />
      </Tooltip>
    </div>
  );
}
